import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { GetDashBoardData, GetUserDetail } from "../../store/Actions/action";
import { useReduxStore } from "../../hooks/useReduxStore";

const useDashboardHome = () => {
  const { getState, dispatch } = useReduxStore();
    const [showKeyModal, setShowKeyModal] = useState(false);
    const [selectedApikey, setSelecetdApiKey] = useState(null);
  const onClickGenerate=()=>{
    // navigate("/Pricing")
    setShowKeyModal(true)
  }

  const {
   cancelSubscription,
   loading,
  } = getState("AUTH");
  const {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
    dashBoardData
  } = getState("Home");
const {apiKeys,subscription:currentSubscription,monthlyUsage,latestBulletins}=dashBoardData||{}
const  getDashobardDataFunc=()=>{
    dispatch(GetDashBoardData({}))
  }
  useEffect(()=>{
getDashobardDataFunc()
  },[])
  useEffect(() => {
   cancelSubscription&& dispatch(GetUserDetail({stopLoading:true}));
  }, [cancelSubscription]);
 useEffect(()=>{
dispatch(GetUserDetail({stopLoading:true}));
 },[])
  return {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
    apiKeys,
    currentSubscription,
    monthlyUsage,
    loading,
    latestBulletins,
    onClickGenerate,
    showKeyModal,
    setShowKeyModal,
    selectedApikey,
    setSelecetdApiKey,
  };
};

export default useDashboardHome;
